import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { set_value_properties } from "../../App/actions/propertiesActions";

const C_V_SELECT = React.memo(
  ({ value, isEditing, isViewer, isAllowOtherAnswer, field, row }) => {
    const dispatch = useDispatch();
    const cellRef = useRef(null);

    // --- THE TRIGGER: Only activate when this specific cell is double-clicked ---
    useEffect(() => {
      if (isEditing && !isViewer && cellRef.current) {
        // 1. Grab the raw array templates safely
        const base_options = field.array_templates || [];
        let final_options = base_options;

        // 2. Handle nested/parent filtering if it exists
        const parent_array_templates_key = field.parent_array_templates_key;
        const value_parent = row?.properties?.[parent_array_templates_key];

        if (parent_array_templates_key && value_parent) {
          final_options = base_options.filter(
            (item) => item.parent === value_parent,
          );
        }

        // 3. Dispatch to the Global Redux Modal
        dispatch(
          set_value_properties({
            key: "global_cell_editor",
            value: {
              type: field.type,
              anchorEl: cellRef.current,
              row: row,
              field: field,
              value: value,
              options: final_options.length > 0 ? final_options : base_options,
              isAllowOtherAnswer: isAllowOtherAnswer,
            },
          }),
        );
      }
    }, [isEditing, isViewer, field, row, value, isAllowOtherAnswer, dispatch]);

    // --- THE FAST RENDERER ---
    const displayValue = Array.isArray(value) ? value.join(", ") : value;

    return (
      <div
        ref={cellRef}
        className="cell_text_fast"
        title={displayValue}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {displayValue || "-"}
        </span>

        {/* Visual indicator that this is a dropdown */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#999" // Light grey so it's subtle and not distracting
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ flexShrink: 0, marginLeft: "4px" }}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>
    );
  },
);

export default C_V_SELECT;
